import React from 'react';
import ResultsGroupView from '../ResultsGroupView';
import AssetTile from '../assetTile/AssetTile';

const EquipByFloorView = ({ equipmentByFloor, handleEquipSelection }) => {
  const equipByFloorResults = equipmentByFloor.map((floor) => ({
    name: floor.name,
    items: floor.equipment.map((equip) => (
      <AssetTile
        key={`${floor.name}-${equip.typeName}`}
        flipEnabled
        flipLabel="Quick View >"
        frontTitle={equip.display.fullName}
        frontSubtitle={equip.display.typeName}
        frontRightInfo={`Points: ${equip.points?.length || 0}`}
        frontDrilldownFunc={(e) => handleEquipSelection(e, equip.id)}
        frontDrilldownEnabled
        backDrilldownFunc={(e) => handleEquipSelection(e, equip.id)}
        backDrilldownLabel="Details"
        backRightInfo={equip.display.fullName}
      />
    )),
  }));

  return <ResultsGroupView loading={false} groups={equipByFloorResults} />;
};

export default EquipByFloorView;
